import {
  useDismissBenefitModal,
  useIsBenefitScreenPresentedAsModal,
} from '@/src/experiences/card-benefits/components/BenefitModal'
import { Section } from '@/src/common/components/Section'
import { mesaColorNames, typography } from '@/src/common/theme'

export function CardBenefitsComponentsHeader({
  title,
  screenName,
}: {
  title: string
  screenName: string
}) {
  const isBenefitScreenPresentedAsModal = useIsBenefitScreenPresentedAsModal()
  const color = isBenefitScreenPresentedAsModal
    ? mesaColorNames['Mesa - Brand/Secondary #223843']
    : mesaColorNames['Mesa - Brand/White #FFFFFF']

  const dismissBenefitModal = useDismissBenefitModal(screenName)

  return (
    <Section
      title={title}
      titleStyles={[{ color }, typography['label/lg-bold']]}
      style={[
        { paddingVertical: 16, height: 'auto', marginBottom: 0 },
        isBenefitScreenPresentedAsModal && {
          backgroundColor: mesaColorNames['Greyscale/0 #FFFFFF'],
        },
      ]}
      {...(isBenefitScreenPresentedAsModal
        ? { onClosePress: dismissBenefitModal }
        : { onBackPress: dismissBenefitModal, chevronColor: color })}
    />
  )
}
